import { Injectable } from '@angular/core';
import { HttpGeneralService, InPatientParms } from '../../shared';
import { CONFIG } from '../../shared/config';
let inpatientlistUrl = CONFIG.baseUrls.inpatientlist;
export interface OrdersData {
  orderSerial: number;
  orderStatus: number;
  visitSerial: number;
}
export interface RegPatRequests {
  serial?: number
  docId: number
  expectedDocId: number
  visitSerial: number
  status: number
  orderType: number
  serviceCode: number
  discountValue: number
  percentOrValue: number
  cshDiscountsCode: number

}

@Injectable()
export class OrdersService {
  constructor(private httpGeneralService: HttpGeneralService) { }
  getOrdersData(inPatientParms: InPatientParms) {
    return this.httpGeneralService.add(inPatientParms, `${inpatientlistUrl}/getOrderRequestData`);
  }
  updateOrdersData(OrdersData: OrdersData) {
    //  return this.httpGeneralService.add(inPatientParms, `${inpatientlistUrl}/PutOrderList`);
    return this.httpGeneralService.update(OrdersData.orderSerial, OrdersData, `${inpatientlistUrl}/PutOrderList`);

  }
  updateOrderRequestDoctorData(OrdersData: RegPatRequests) {
    //  return this.httpGeneralService.add(inPatientParms, `${inpatientlistUrl}/PutOrderList`);
    return this.httpGeneralService.update(OrdersData.serial, OrdersData, `${inpatientlistUrl}/PutOrderRequestDoctorData`);

  }
  getNewReservationRequestDetails(RegPatRequestOrders: any) {
    return this.httpGeneralService.post(RegPatRequestOrders, `${inpatientlistUrl}/getNewReservationRequestDetails`);
  }
}
